import { Icon } from '@/src/components/ui';
import { shortRelativeTime } from '@/src/utils/helpers';

type Props = {
  name: string;
  uniqueLink: string;
  level: number;
  createdAt: Date;
};

export const AuthorBlock = ({ name, uniqueLink, level, createdAt }: Props) => {
  const created = shortRelativeTime(createdAt);
  const isDeleted = name === 'Deleted User';
  return (
    <div className="flex flex-col gap-1.5" data-no-card-click="true">
      <div className="flex items-center text-sm md:text-base gap-1 text-bluesky-gray font-normal">
        <a
          href={`/${uniqueLink}`}
          className="font-semibold text-black hover:text-blue-primary transition-colors duration-300"
        >
          {name}
        </a>
        {!isDeleted && (
          <a
            href={`/${uniqueLink}`}
            className="hover:text-blue-primary transition-colors duration-300"
          >
            @{uniqueLink}
          </a>
        )}

        <span className="font-bold">·</span>
        {created}
      </div>
      <div className="flex items-end gap-1">
        <Icon name="lvl" className="h-2 w-6 text-black ml-1" />
        <Icon name={level.toString()} className="h-2.5 w-3 text-black" />
      </div>
    </div>
  );
};
